import { render } from "./ScrollSpyText.vue?vue&type=template&id=ae2a4bd2"
import script from "./ScrollSpyText.vue?vue&type=script&lang=js"
export * from "./ScrollSpyText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Navigation/ScrollSpyText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ae2a4bd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ae2a4bd2', __exports__)) {
    api.reload('ae2a4bd2', __exports__)
  }
  
  module.hot.accept("./ScrollSpyText.vue?vue&type=template&id=ae2a4bd2", () => {
    api.rerender('ae2a4bd2', render)
  })

}


export default __exports__